import * as React from 'react';
import IconButton from 'ha/ui/next/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Grid from 'ha/ui/next/Grid';

interface Props {
  onOpenMobileDrawer: () => void;
}

const UnauthenticatedNavigationMobile: React.SFC<Props> = ({
  onOpenMobileDrawer,
}) => (
  <Grid item>
    <IconButton onClick={onOpenMobileDrawer}>
      <MenuIcon />
    </IconButton>
  </Grid>
);

export default UnauthenticatedNavigationMobile;
